import Smartphones from './containers/Smartphones'
import Tablets from './containers/Tablets'
import './FactoringInfoView.scss?global'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const FactoringInfoView = getCurrentDeviceView(Smartphones, Tablets)

export default FactoringInfoView
